// extracted by mini-css-extract-plugin
export default {"root":"f51DC","header":"i6ors","ellipsis":"WfFUE","headerContent":"_5iPQ","nogrow":"NnOLG","cardBody":"SDlRP","description":"yiquU","title":"eJ2yU","iconFallback":"cL1Ed"};